import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { ResponsivePicture } from "../../../Shared/components/Image";
import { classNamesConfig } from '../../../Shared/features/classnames';
import { Block } from './library/container';
export const ImageBlock = (p)=>{
    const blockClassNames = classNamesConfig().media;
    return /*#__PURE__*/ _jsx(Block, {
        children: /*#__PURE__*/ _jsx("div", {
            className: `block block--image block--media ${blockClassNames.block} `,
            children: /*#__PURE__*/ _jsx("div", {
                className: `block__inner ${blockClassNames.inner}`,
                children: /*#__PURE__*/ _jsx("div", {
                    className: "block__visual",
                    children: /*#__PURE__*/ _jsx(ResponsivePicture, {
                        imgClassName: "block__image",
                        defaultImageUrl: p.imageUrlFallback,
                        cropsPerMedia: [
                            {
                                crops: [
                                    {
                                        url: p.imageUrlSmall,
                                        width: 400
                                    },
                                    {
                                        url: p.imageUrl,
                                        width: 800
                                    },
                                    {
                                        url: p.imageUrlLarge,
                                        width: 1600
                                    }
                                ]
                            }
                        ],
                        width: "100%",
                        alt: p.imageAlt
                    })
                })
            })
        })
    });
};
{
/* TH: Added to styleguide! */ }